import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "./supabase-public"

/**
 * Where the server lives — FCS-055.
 * ============================================================================
 * Nowhere in this repo, is the short answer. The site is static on GitHub
 * Pages, so `/api/anything` is a 404 in production no matter how well the
 * Gatsby route beside it works. Every server-side call goes to a Supabase
 * Edge Function instead, and this is the one place that address is built.
 *
 * The Gatsby routes under src/api are kept for local development, where they
 * answer on the same origin and are quicker to iterate on. The two are the
 * same contract written for two runtimes — change one, change both.
 */

export const API_BASE = `${SUPABASE_URL}/functions/v1`

/** The full URL of a function by name. */
export const apiUrl = name => `${API_BASE}/${name}`

/**
 * Calls a function, carrying whoever is signed in.
 *
 * The publishable key is sent as `apikey` because the platform's gateway
 * expects one; the Authorization header carries the SESSION when there is
 * one, which is how the function knows who is asking. With nobody signed in
 * both are the publishable key, and `_shared/auth.ts` treats that as "no
 * user" rather than mistaking the key for an identity.
 */
export async function callApi(name, { body, session, headers = {} } = {}) {
  const token = session?.access_token || SUPABASE_PUBLISHABLE_KEY

  const res = await fetch(apiUrl(name), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: SUPABASE_PUBLISHABLE_KEY,
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    body: JSON.stringify(body || {}),
  })

  /* A function that fell over returns a page, not JSON, and the resulting
     "Unexpected token <" tells the caller nothing about what happened. */
  let payload = null
  try {
    payload = await res.json()
  } catch {
    payload = { message: "That did not work. Please try again in a moment." }
  }

  return { ok: res.ok, status: res.status, body: payload }
}
